import { isSameDay } from 'date-fns';

import { Message } from '@web/conversations/types/Message';
import { MessageType } from '@web/conversations/types/MessageType';

type ID = number;
type Props = {
  firstUnreadMessageId: ID;
  markedMessage: {
    id: ID | null;
    isHighlighted: boolean;
  };
  message: Message;
  newestMessage?: Message;
  precedingMessage?: Message;
};
export const getMessageUIFlags = ({
  firstUnreadMessageId,
  markedMessage,
  message,
  newestMessage,
  precedingMessage,
}: Props) => {
  const isFirstUnread = message.id === firstUnreadMessageId;
  const isMarked = message.id === markedMessage.id;
  const isHighlighted = isMarked && markedMessage.isHighlighted;
  const isNewest = message.id === newestMessage?.id;

  const precedingHasSameDay =
    precedingMessage && isSameDay(message.postedAt, precedingMessage.postedAt);
  const withDateSeparator = !precedingHasSameDay;

  const precedingHasSameAuthor = message.author.id === precedingMessage?.author.id;
  const withHeader =
    precedingMessage?.type !== MessageType.MESSAGE ||
    !precedingHasSameDay ||
    !precedingHasSameAuthor;

  return {
    isFirstUnread,
    isHighlighted,
    isMarked,
    isNewest,
    withDateSeparator,
    withHeader,
    withNewSeparator: isFirstUnread,
  };
};
